import { PhoneIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'
import { FC, useState } from 'react'

import { useContactInfo } from '@/api/models/common/hooks/useContactInfo'
import {
  AppQrModal,
  AppsBlock,
  ContactsModal
} from '@/components/entities/common/ui'
import { formatPhoneNumber } from '@/utils/number'

import { QrStoreType } from './Sidebar.types'

type Props = {
  className?: string
  isSidebarExpanded: boolean
}

const SidebarContacts: FC<Props> = ({ className, isSidebarExpanded }) => {
  const [contactsModalOpened, setContactsModalOpened] = useState(false)
  const [qrOpened, setQrOpened] = useState(false)
  const [qrStore, setQrStore] = useState<QrStoreType>(QrStoreType.appGallery)

  const { data: contactInfo, hasContactInfo } = useContactInfo()

  return (
    <>
      <div
        className={clsx(
          'border-t border-grey-90 p-30',
          !isSidebarExpanded && 'hidden',
          className
        )}
      >
        <AppsBlock setQrStore={setQrStore} setQrOpened={setQrOpened} />

        {hasContactInfo && (
          <>
            <div className="mb-16 mt-24 h-1 w-full bg-grey-90"></div>

            <div className="flex flex-col space-y-4">
              <div className="font-pro text-grey-60 text-18">
                Служба комфорта 24/7
              </div>

              {contactInfo?.contactPhone && (
                <a
                  href={`tel:${contactInfo.contactPhone}`}
                  className="font-bold text-white transition-colors text-24 hover:text-grey-50"
                >
                  {formatPhoneNumber(contactInfo.contactPhone)}
                </a>
              )}
              {contactInfo?.contactEmail && (
                <a
                  href={`mailto:${contactInfo.contactEmail || ''}`}
                  className="font-pro text-bronze-40 transition-colors text-18 hover:text-bronze-60"
                >
                  {contactInfo.contactEmail}
                </a>
              )}
            </div>
          </>
        )}
      </div>

      {hasContactInfo && (
        <div
          className={clsx(
            'border-t border-grey-90 px-20 py-22',
            isSidebarExpanded && 'hidden',
            className
          )}
        >
          <button
            aria-label="Открыть модальное окно контактов"
            className="block rounded-8 p-10 text-grey-50 transition-colors hover:text-white/50"
            onClick={() => setContactsModalOpened(true)}
          >
            <PhoneIcon className="h-24 w-24" />
          </button>
        </div>
      )}

      {qrOpened && (
        <AppQrModal
          store={qrStore}
          opened={qrOpened}
          onClose={() => setQrOpened(false)}
        />
      )}

      <ContactsModal
        opened={contactsModalOpened}
        onClose={() => setContactsModalOpened(false)}
        setQrStore={setQrStore}
        setQrOpened={setQrOpened}
      />
    </>
  )
}

export { SidebarContacts }
